/**
 * This component renders a tab button for all tab bars, used for consistent styling
 */
import React from "react";

const TabButton = ({ first, tabName, activeTab, handleTabClick, label }) => {
  return (
    <button
      onClick={() => handleTabClick(tabName)}
      className={
        `${first ? "border-l-2" : ""} ` + // Conditionally add border-l-2 if 'first' is true
        (activeTab === tabName
          ? "active bg-light-1 dark:bg-dark-1 xs:mx-2 dark:text-dark-5 h-10 w-28 xs:rounded-t border-t-2 border-r-2 xs:border-x-2 border-light-3 dark:border-dark-3 max-xs:text-xxs xs:max-sm:text-xs"
          : "dark:bg-dark-4 bg-light-2 xs:mx-2 hover:text-buiha-red hover:bg-light-1 dark:hover:bg-dark-2 dark:hover:text-dark-5 h-10 w-28 xs:rounded-t border-r-2 border-t-2 xs:border-x-2 border-light-3 dark:border-dark-3 max-xs:text-xxs xs:max-sm:text-xs ease-in-out duration-200")
      }
    >
      <p className="dark:hover:text-dark-5 hover:text-buiha-red ease-in-out duration-200"
      >{label}</p>
    </button>
  );
};

export default TabButton;